import { enableProdMode, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import '@angular/compiler';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { APP_ENVIRONMENT } from '@gwc/core/config/environment.token';
import { AppComponent } from './app/app.component';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { CasualHireFormModule } from './app/pages/casual-hire-form/casual-hire-form.module';
import { FormsLayoutModule } from '@gwc/forms-layout/forms-layout.module';
import { LoadingModule } from '@gwc/loading/loading.module';
import { appConfig } from '@gwc/core/config/app.config';
import { F3ConfigModule } from '@f3/services/config';
import { F3Module } from '@f3';
import { withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideNativeDateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { AppRoutingModule } from './app/app-routing.module';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule, AppRoutingModule, F3Module, F3ConfigModule.forRoot(appConfig), LoadingModule, FormsLayoutModule, CasualHireFormModule, FontAwesomeModule),
        provideAppInitializer(() => {
        const initializerFn = ((library: FaIconLibrary) => () => library.addIconPacks(fas))(inject(FaIconLibrary));
        return initializerFn();
      }),
        provideAnimations(),
        provideNativeDateAdapter(),
        { provide: MAT_DATE_LOCALE, useValue: 'en-NZ' },
        provideHttpClient(withInterceptorsFromDi()),
        { provide: APP_ENVIRONMENT, useValue: environment }
    ]
})
  .catch(err => console.error(err));
